import React, { FC } from "react";
import styles from "./ErrorPrompt.module.scss";
import errorIcon from "../../assets/icon-error.svg";

interface ErrorPromptProps {
  text: string;
}
const ErrorPrompt: FC<ErrorPromptProps> = ({ text }) => {
  return (
    <div className={styles.ErrorContainer}>
      <img src={errorIcon} alt="Error Icon" />
      {text}
    </div>
  );
};

export default ErrorPrompt;
